module.exports = __webpack_public_path__ + "media/images/emblems/Cossonay-coat_of_arms-06e8d8b67ea52a4001efd1c951707391.svg";